import React from 'react';
import styled from 'styled-components';
import AuthService from '../services/authService';

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 0 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Pill = styled.button`
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #4b5563;
  font-size: 12px;
  padding: 6px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover { background: #eef2ff; border-color: #c7d2fe; color: #111827; }
`;

const IconButton = styled.button`
  border: none;
  background: transparent;
  color: #4b5563;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  &:hover { background: #f3f4f6; color: #111827; }
`;

const TextButton = styled.button`
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #dc2626;
  font-size: 12px;
  padding: 6px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover { background: #fef2f2; border-color: #fecaca; }
`;

export default function StudentTopBar({ title, onMenuClick }) {
  const user = AuthService.getUser() || {};
  const selected = user.selectedRegistration || null;

  const label = selected
    ? `${selected.courseShortName || selected.courseName || 'Course'} · ${selected.registrationNumber}`
    : 'No course selected';

  const onChangeCourse = () => {
    window.location.replace('/app/select-course');
  };

  const onLogout = () => {
    try {
      AuthService.clear();
    } catch (_) {}
    window.location.replace('/login');
  };
  return (
    <Header>
      <Left>
        <IconButton onClick={onMenuClick} aria-label="Toggle menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
        </IconButton>
        {title && <h1 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>{title}</h1>}
      </Left>
      <Right>
        <Pill type="button" onClick={onChangeCourse}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: '#22c55e' }} />
          <span>{label}</span>
        </Pill>
        <TextButton type="button" onClick={onLogout}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
          Logout
        </TextButton>
      </Right>
    </Header>
  );
}
